export default __webpack_public_path__ + "static/LogoCurrent-1869ce7e6db32c431cee2b1e9f9c293a.png";